<template>
    <span class="rounded-full" :style="{ backgroundColor: props.color, width: '0.563rem', height: '1.25rem' }" />
</template>

<script setup lang="ts">

const props = defineProps({
    color: {
        type: String,
        default: '#000000',
    }
});

// ───── Composables & Stores ─────


// ───── State / Refs ─────


// ───── API States ─────


// ───── Computed ─────


// ───── Methods ─────
</script>
